import { useEffect, useState } from "react";
import { QuestionItem } from "./SendMessage";

export type Message =
  | {
      type: "question";
      id: string;
      content: QuestionItem["question"];
    }
  | {
      type: "answer";
      id: string;
      content: QuestionItem["options"];
      correct: boolean;
    };

interface UseProgressTrackerProps {
  question: {
    series?: QuestionItem[];
  } | null;
  messages: Message[];
}

export const useProgressTracker = (question: any, messages: any): string => {
  const [progress, setProgress] = useState<string>("0");

  useEffect(() => {
    const totalQuestions = question?.series?.length || 0;

    const correctAnswers = messages.filter(
      (msg: any) => msg.type === "answer" && msg.correct
    ).length;

    const answeredProgress =
      totalQuestions > 0
        ? ((correctAnswers / totalQuestions) * 100).toFixed(2)
        : "0";

    setProgress(answeredProgress);
  }, [messages, question]);

  return progress;
};
